import { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import LoginStyles from './LoginStyles';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';
import { navigate } from "@reach/router";
import { Logo, Button, MaskedTextField } from "ams-ui-reactkit";
import { IsLoggedIn } from '../../utils/Utils';
import { StoreContext } from './../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { actionTypeConstants } from '../../utils';

export type LoginViewProps = {
  templateProps: {
    statusBarOptions?: any,
    callButtons?: any
    sidebarItemList?: any,
    nextScreen?: string
  },
  url?: any
  history: History
};

Amplify.configure(awsconfig);

const Login = (props: LoginViewProps) => {
  const classes = LoginStyles();
  const [uname, setUserName] = useState("");
  const [pwd, setPwd] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showErrorMes, setShowErrorMes] = useState(false);
  const [errorMes, setEerrorMes] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

  const handleClick = async () => {
    setLoading(true);
    await Auth.signIn(uname, pwd).then((res: any) => {
      dispatch({
        'type': actionTypeConstants.UPDATE_USER,
        'payload': { ...res.attributes, "username": res.attributes.name }
      })
      setLoading(false);
      //@ts-ignore
      navigate(props?.templateProps?.nextScreen || "/")

      setLoading(false)
    })
      .catch((e: any) => {
        if (e) {
          setEerrorMes("Username or Password are incorrect.");
          setShowErrorMes(true);
          setLoading(false)
        }
      })
  }

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter" && !disabled) {
      handleClick();
    }
  }

  useEffect(() => {
    uname.length >= 3 && pwd.length >= 3 ? setDisabled(false) : setDisabled(true)
  }, [uname, pwd]);

  useEffect(() => {
    IsLoggedIn().then((result: any) => {
      if (result) {
        navigate(props?.templateProps?.nextScreen || "/bol")
      }
    });
  }, [])

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.mainContainer}
    >
      <Grid item xs={3} className={classes.mainContainerinr}>
        <div className={classes.loginTemplate}>
          <div className={classes.loginTemplateinr}>
            <div className={classes.loginTemplateFields}>
              <div className={classes.logoView}>
                <Logo />
              </div>
              <div className={classes.loginSinglerow}>
                <MaskedTextField
                  autoComplete="username"
                  inputProps={{
                    minLength: 1,
                    type: "text"
                  }}
                  label="Username"
                  onChange={(e: any) => { setUserName(e.target.value); }}
                  variant="standard"
                  id="username"
                  multiline={false}
                  isMask={false}
                />
              </div>
              <div className={classes.loginSinglerow}>
                <MaskedTextField
                  autoComplete="password"
                  inputProps={{
                    minLength: 1,
                    type: "password"
                  }}
                  multiline={false}
                  type="password"
                  label="Password"
                  onChange={(e: any) => {
                    setPwd(e.target.value);

                  }}
                  variant="standard"
                  id="password"
                  isMask={false}
                  onKeyDown={handleKeyPress} />
              </div>
              {showErrorMes ? <span className={classes.errorMessage}>{errorMes}</span> : null}
            </div>
            <div className={classes.loginSinglerow}>
              <Button
                color="primary"
                onClick={handleClick}
                text="LOGIN"
                loading={loading}
                size="large"
                variant="contained"
                disabled={disabled}
              />
            </div>

          </div>
        </div>
      </Grid>
    </Grid>
  );

}

export default Login